// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__KwFgF","inputWrap":"styles_inputWrap__yPy_p","input":"styles_input__3eONp"};